<template>
<div>
    <el-switch v-model="scale" inactive-text="Log" active-text="Linear" :inactive-value="'logarithmic'" :active-value="'linear'" @change="updateChart"></el-switch>
    <canvas id="stakeDist"></canvas>
</div>
</template>

<script>

import { Chart, LinearScale } from "chart.js";
let nc = 0
let type = 'logarithmic'
export default {
    name: "StakeDistribution",
    props: ['data','nc'],
    data() {
        return {
            scale: 'logarithmic',
            chart:null,
            type: 'logarithmic',
        }
    },
    mounted() {
        // console.log(this.data)
        let sortable = []
        for (let i in this.data) {
            sortable.push([i, this.data[i]])
        }
        sortable.sort(function(a, b) {
            return b[1] - a[1]
        })
// console.log(sortable)
        let objSorted = {}
        sortable.forEach(function(item){
            objSorted[item[0]]=item[1]
        })
        let ctx = document.getElementById("stakeDist").getContext("2d");
        nc = this.nc
        let config = {
            type: "bar",
            data: {
                datasets: [
                    {
                        label: "Stake",
                        data: objSorted,
                        backgroundColor(ctx) {
                            let index = ctx.dataIndex;
                            if (index > nc) {
                                return 'rgba(0, 255, 0, 0.8)';
                            }
                            return 'rgba(255, 99, 0, 0.8)';
                        },
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                        },
                    },
                    y: {
                        type: type,
                        grid: {
                            display: false
                        },
                        ticks: {
                            maxTicksLimit: 6,
                        }
                    }
                }
            }
        }
        let c = new Chart(ctx, config);
        console.log(config,c)
        Object.seal(c)
        this.chart = c
    },
    methods: {
        toTitleCase(str) {
            return str.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        },
        updateChart() {
            console.log('update')
            type = this.scale
            if(!this.chart) return
            this.chart.options.scales.y.type = type
            // this.chart.data.datasets[0].key = this.valueField;
            // this.chart.data.datasets[0].groups = this.groups;
            // maximumValue = this.valueField == 'active_stake' ? totalStake : totalNodes
            // console.log(this.chart.data.datasets[0].key)
            // on next tick
            // this.$nextTick(() => {
            this.chart.update();
            // });
        },
    },
}
</script>

<style scoped>

</style>
